import React from 'react';
import Btn from '../Common/Btn';
import './PauseMenu.css'

const LoseScreen = (props) => {
    return ( 
        <div className='PauseMenu'>
            <div className='PauseTitle'>
                <p>
                    Mission Failed
                </p>
            </div>

            <div className='MenuBtns'>
                <Btn BtnText='Retry' BtnStyle='BlueBtn' onClick={props.RetryClick}/>
                <Btn BtnText='Quit' BtnStyle='GoldBtn' BtnPath='/'/>
            </div>
        </div>
     );
}
 
export default LoseScreen;